// 新着情報の一覧データ。FVのティッカー（最新2件）と新着一覧ページで共有する。
// 記事を追加するときは、この配列に1件追加し、対応する詳細ページを src/pages/news/ に作成する。
export const newsList = [
  {
    date: "2026.06.16",
    title: "Jiteraとセールスパートナー契約を締結しました",
    path: "/news/jitera-partnership/",
    excerpt:
      "AIコンテキストプラットフォームの活用で、企業のDX・AI化を高速化します。",
    image: "",
  },
  {
    date: "2026.06.01",
    title: "AI導入をトータルで伴走支援するAI導入支援サービスを提供開始しました",
    path: "/news/ai-support-service/",
    excerpt:
      "生成AI・AIエージェントの導入計画から研修・運用の定着化までを一気通貫で伴走支援します。",
    image: "",
  },
];
